export default "__VITE_ASSET__D43wBSJ4__"